<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div class="form-title padding-title">
        {{ title }}
      </div>
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />
            <div
              class="form_label"
              v-text="'Nombre de empresa *'"
            />
            <div class="form__field">
              <label for="nombreEmpresa">
                <v-icon
                  name="user"
                  scale="1"
                  style="margin: 1px 1px 0"
                />
              </label>
              <input
                id="nombreEmpresa"
                ref="nombreEmpresa"
                v-model="nombreEmpresa"
                autocomplete="off"
                type="text"
                name="nombreEmpresa"
                value=""
                placeholder="Gatblac"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('cantidadEmpleados')"
                @keypress="keyPressCheckSpecialChars($event, 'fantasyName')"
                @change="cleanSpecialChars('nombreEmpresa', 'fantasyName')"
              >
            </div>
            <div
              class="form_label"
              v-text="'Cantidad de empleados *'"
            />
            <div class="form__field">
              <label for="cantidadEmpleados">
                <v-icon
                  name="user"
                  scale="1"
                  style="margin: 1px 1px 0"
                />
              </label>
              <input
                id="cantidadEmpleados"
                ref="cantidadEmpleados"
                v-model="cantidadEmpleados"
                autocomplete="off"
                type="number"
                name="cantidadEmpleados"
                value=""
                placeholder="1"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('nombreCompleto')"
                @keypress="keyPressCheckSpecialChars($event, 'companySize')"
                @change="cleanSpecialChars('nombreEmpresa', 'companySize')"
              >
            </div>
            <div
              class="form_label"
              v-text="'Nombre Completo *'"
            />
            <div class="form__field">
              <label for="nombreCompleto">
                <v-icon
                  name="user"
                  scale="1"
                  style="margin: 1px 2px 0 4px"
                />
              </label>
              <input
                id="nombreCompleto"
                ref="nombreCompleto"
                v-model="nombreCompleto"
                autocomplete="off"
                type="text"
                name="nombreCompleto"
                value=""
                placeholder="James Perez"
                required
                @focus="_clearError"
                @keyup.enter="_sentClick"
                @keypress="keyPressCheckSpecialChars($event, 'personContact')"
                @change="cleanSpecialChars('nombreCompleto', 'personContact')"
              >
            </div>
            <div
              class="form_label"
              v-text="'RUT *'"
            />
            <div class="form__field">
              <label for="rut">
                <v-icon
                  name="address-card"
                  scale="1"
                  style="margin-top: 3px"
                />
              </label>
              <input
                id="rut"
                ref="rut"
                v-model="rut"
                autocomplete="off"
                type="text"
                name="rut"
                value=""
                placeholder="XX.XXX.XXX-X"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('telefono')"
                @keypress="keyPressCheckSpecialChars($event, 'rut')"
                @change="_formatearRut($event.target.value)"
              >
            </div>
            <div
              class="form_label"
              v-text="'Teléfono *'"
            />
            <div class="form__field">
              <label for="telefono">
                <v-icon
                  name="mobile-alt"
                  scale="1"
                  style="margin: 1px 2px 0 4px"
                />
              </label>
              <input
                id="telefono"
                ref="telefono"
                v-model="telefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="+569 1 234 5678"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('nombreCompleto')"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
              >
            </div>
            <div
              class="form_label"
              v-text="'Ingresa tu email *'"
            />
            <div class="form__field">
              <label
                for="email"
              ><v-icon
                name="envelope"
                scale="1"
                style="margin-top: 2px"
              /></label>
              <input
                id="email"
                ref="email"
                v-model="email"
                class="email"
                autocomplete="off"
                type="text"
                name="email"
                value=""
                placeholder="usuario@dominio.com"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('telefono')"
                @keypress="keyPressCheckSpecialChars($event, 'email')"
                @change="cleanSpecialChars('email', 'email')"
              >
            </div>
            <div
              class="form_label"
              v-text="'Seleccione el tipo de prueba'"
            />
            <select
              id="form_estilos"
              v-model="tipoSkill"
              :multiple="false"
              class="formulario_combo"
              @change="_seleccionSkill($event.target.value)"
            >
              <option
                v-for="skill in skillList"
                :value="skill.name"
              >
                {{ skill.name }}
              </option>
            </select>
          </div>
        </vuescroll>
      </div>
      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from '../../main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/shipping-fast'
import formUtils from '../../formUtils'
import utils from '../../utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  methods: {
    ...formUtils.formBase,
    _seleccionSkill () {
      this.errormsg = ''
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.nombreEmpresa) {
        this.errormsg = 'Debes ingresar el nombre de tu empresa'
        return
      }
      if (this.rut === '') {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingresar tu rut'
        return
      }
      if (!utils.validaRut(this.rut)) {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingresar RUT válido'
        return
      }
      if (!this.cantidadEmpleados) {
        this.errormsg = 'Debes ingresar la cantidad de empleados en tu empresa'
        return
      }
      if (!this.telefono) {
        this.errormsg = 'Debes ingresar el teléfono'
        return
      }
      if (this.telefono.length <= 8) {
        this.errormsg = 'Debes ingresar teléfono válido'
        return
      }
      if (!this.email) {
        this.errormsg = 'Debes ingresar email'
        return
      }
      if (!utils.isEmail(this.email)) {
        this.errormsg = 'Formato email incorrecto'
        return
      }
      if (!this.nombreCompleto) {
        this.errormsg = 'Debes ingresar tu nombre completo'
        return
      }
      const dataToSend = {
        form: 'GatblacNewChatbotRequest',
        evento: 'sentClick',
        data: {
          type: 'gatblac-chatbot-request-confirm',
          fields: {
            companyName: this.nombreEmpresa,
            rut: this.rut,
            phone: this.telefono,
            email: this.email,
            fullName: this.nombreCompleto,
            skillType: this.tipoSkill,
            companySize: this.cantidadEmpleados
          }
        }
      }

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'GatblacNewChatbotRequest',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  },
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      nombreEmpresa: '',
      cantidadEmpleados: '',
      rut: '',
      telefono: '',
      email: '',
      nombreCompleto: '',
      tipoSkill: '',
      skillList: []
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'GatblacNewChatbotRequest') return
      if (e.evento === 'init') {
        // console.log("asigna por init:");
        // console.log("e.dato:",e.dato);
      }
      if (e.evento === 'newdata') {
        // console.log("asigna por newdata:");
        // console.log("e.dato:",e.dato);
        console.log('e.dato.fields > ', e.dato.fields)
        this.title = e.dato.title ? e.dato.title : 'Solicitud de ChatBot'
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone ? e.dato.fields.phone : ''
        this.skills = e.dato.fields.skills ? e.dato.fields.skills : []

        this.nombreCompleto = this.nombreOrigen
        this.email = this.emailOrigen
        this.telefono = this.telefonoOrigen
        this.skillList = this.skills
        this.tipoSkill = this.skills[0].name
      }
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
	margin-bottom: 7px;
}

.form-box-body {
	height: 335px;
}
</style>
